import { useEffect, useState } from "react";
import { ResponseSweetTrackerDto } from "../dto/dto.interface";


export default function useTrackingFetch(num: string) {
  const [data, setData] = useState<ResponseSweetTrackerDto>();

  useEffect(() => {
    console.log(num)
   
    fetch(`https://sweettracker.logisteq.com/kangdong/invoiceInfo?num=${num}`)
      .then(res => {
        return res.json();
      })
      .then(data => {
        setData(data);
      });
  }, [num]);

  return data;
}
